import React from 'react';

function MemoComponent({ children, props }) {
    
    return (
        <>{children}</>
    )
}
function areEqual(prevProps, nextProps) {
    return true;
}

export default React.memo(MemoComponent, areEqual);